// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__tf5Kj","buttons":"Footer_buttons__2e9Hv"};